import { Container, Box } from "@sembark-travel/ui/base"
import {
	useGetBackUrlFromLocation,
	Breadcrumbs,
} from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../router-utils"
import { NewTripDestination } from "../../../TripDestinations"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function NewTripDestinationPage() {
	const navigate = useNavigate()
	const backFromUrl = useGetBackUrlFromLocation()
	return (
		<>
			<Helmet>
				<title>New Trip Destination</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.ADD_TRIP_DESTINATIONS}>
				<Breadcrumbs
					title="New Destination"
					items={[
						[generatePath("/org/trip-destinations"), "Trip Destinations"],
						["", "New"],
					]}
				/>
				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="4xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<NewTripDestination
									onSuccess={() => navigate("/org/trip-destinations")}
									onCancel={() =>
										backFromUrl
											? navigate(backFromUrl as "/org/trip-destinations", {
													replace: true,
											  })
											: navigate("/org/trip-destinations", { replace: true })
									}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
